/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { UnitDependencies } from './dependenciesUnitClass.generated';
import { createSpeedOfLight } from '../../factoriesAny.js';
export var speedOfLightDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  UnitDependencies: UnitDependencies,
  createSpeedOfLight: createSpeedOfLight
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesSpeedOfLight.generated.js
// module id = 1519
// module chunks = 0